import { useState } from "react";
import { SelectOption } from ".";

type Props = {
    options: SelectOption[];
    defaultValue: string | number;
    onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
};

export const useSelect = ({ options, defaultValue, onChange }: Props) => {
    const [selected, setSelected] = useState(
        options.find(option => option.value === defaultValue)
    );

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const raw = event.target.value;
        const normalized = typeof defaultValue === 'number' ? Number(raw) : raw;
        const selectedOption = options.find(option => option.value === normalized);

        if (selectedOption) {
            setSelected(selectedOption);
            onChange?.(event);
        }
    };

    return { selected, options, handleChange };
};